import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spesa_item_table = _resolveComponent("spesa-item-table")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_video_della_settimana_viewer = _resolveComponent("video-della-settimana-viewer")!
  const _component_menu_step_table = _resolveComponent("menu-step-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_spesa_item_table, {
          readonly: _ctx.readonly,
          items: _ctx.week.spesaItems
        }, null, 8, ["readonly", "items"])
      ]),
      (_ctx.videoList)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Video della settimana",
                  text: "Video della settimana"
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.week.weekVideo) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoList, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item.identifier,
                      value: item
                    }, _toDisplayString(item.name), 9, _hoisted_6))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.week.weekVideo]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.week.weekVideo = null))
                }, " X ")
              ])
            ]),
            (_ctx.week.weekVideo && _ctx.week.weekVideo.identifier)
              ? (_openBlock(), _createBlock(_component_video_della_settimana_viewer, {
                  key: 0,
                  video: _ctx.week.weekVideo
                }, null, 8, ["video"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_menu_step_table, {
          readonly: _ctx.readonly,
          items: _ctx.week.menuList
        }, null, 8, ["readonly", "items"])
      ])
    ])
  ], 64))
}